<template>
  <div>
    <v-dialog
      v-model="DIALOG_ATIVO"
      persistent
      width="550"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title>
          <span>{{ editando ? "Editando" : "Cadastrando" }}</span>
          <v-spacer />
          <v-btn icon @click="fecharDialog" class="ml-n2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-3">
          <div>
            <SysSegmentoAutocomplete
              :key="`segmento-${editedItem.id}-${editedItem.segmentos.join('-')}`"
              v-model="editedItem.segmentos"
              label="Selecione o Segmento*"
              outlined
              multiple
              :disabled="editedItem.id > 0"
              :error-messages="segmentosErros"
              @change="messageError = null"
            />
          </div>

          <div class="mt-6">
            <text-field-formatador
              v-model="editedItem.tempo_cobertura"
              label="Informe o Tempo de Cobertura*"
              outlined
              inteiro
              :remover-valor-irrelevante="true"
              :error-messages="tempoCoberturaErros"
              @focus="$event.target.select()"
              @keyup.enter="salvar()"
            />
          </div>
        </v-card-text>

        <v-card-actions class="d-flex mt-n5">
          <v-spacer />
          <v-btn text color="primary" @click="salvar()"> salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SysSegmentoAutocomplete from "../../../utils/crud/SysSegmentoAutocomplete.vue";
import TextFieldFormatador from "../../../utils/TextFieldFormatadorDeValor.vue";
import TempoCoberturaPorSegmentos from "../../../../api/compras/TempoCoberturaPorSegmentos";

import { required, minValue, maxValue } from "vuelidate/lib/validators";

export default {
  name: "DialogCurvasSegmentos",
  components: {
    TextFieldFormatador,
    SysSegmentoAutocomplete,
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    itemParaEdicao: {
      type: Object,
    },
  },
  data: () => ({
    messageError: null,
    editedItem: {
      id: "",
      segmentos: [],
      tempo_cobertura: "",
    },
  }),
  watch: {
    itemParaEdicao(item) {
      const { id = "", idfamilia_produto = null, tempo_cobertura = "" } = item;

      this.editedItem = {
        id,
        segmentos: idfamilia_produto ? [idfamilia_produto] : [],
        tempo_cobertura,
      };
    },
  },
  validations: {
    messageError: {
      duplicated() {
        return this.messageError === null;
      },
    },
    editedItem: {
      segmentos: {
        required,
      },
      tempo_cobertura: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(99999999),
      },
    },
  },
  computed: {
    editando() {
      return this.editedItem.id && this.editedItem.id > 0;
    },
    DIALOG_ATIVO: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      },
    },
    segmentosErros() {
      const errors = [];
      if (!this.$v.editedItem.segmentos.$dirty) return errors;
      !this.$v.editedItem.segmentos.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    tempoCoberturaErros() {
      const errors = [];
      if (!this.$v.editedItem.tempo_cobertura.$dirty) return errors;
      !this.$v.editedItem.tempo_cobertura.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.tempo_cobertura.minValue &&
        errors.push("Valor mínimo é 1.");
      !this.$v.editedItem.tempo_cobertura.maxValue &&
        errors.push("Valor máximo é 99.999.999.");
      return errors;
    },
  },
  methods: {
    salvar() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          TempoCoberturaPorSegmentos.store(headers, this.editedItem)
            .then((response) => {
              const { token, messageError } = response.data;
              localStorage.token = token;

              if (!messageError) {
                this.fecharDialog();
                this.$emit("atualizar-lista", true);
              } else {
                this.messageError = messageError;
              }
            })
            .catch(() => this.Helpers.logout())
        );
      }
    },
    fecharDialog() {
      this.DIALOG_ATIVO = false;
      this.messageError = null;
      this.$v.$reset();

      this.editedItem = {
        id: "",
        segmentos: [],
        tempo_cobertura: "",
      };
    },
  },
};
</script>

<style>
</style>
